import { IFilter } from '../../types/filters';
import { ContactPhoneContainer } from '../../containers/advancedFilters/ContactPhoneContainer';

export const contact: IFilter = {
  component: ContactPhoneContainer,
};
